export default __webpack_public_path__ + "static/media/avater.49e2dc7b.png";